module.exports = __webpack_public_path__ + "static/media/23004519_1638427856232399_6677637419811693235_o.da773f5b.jpg";